export const breakpoints = {
  superLargeDesktop: { max: 4000, min: 3000 },
  desktop: { max: 3000, min: 1024 },
  tablet: { max: 1024, min: 464 },
  mobile: { max: 464, min: 350 },
  smallMobile: { max: 350, min: 0 },
};
